import Player from '@vimeo/player';
const videos = document.querySelectorAll('[data-vimeo-url]');

const vimeoPlayer = () => {
    if (videos.length) {
        videos.forEach(video => {
            let player = new Player(video);

            player.setQuality('360p');

            player.on('play', function() {
                player.element.parentElement.classList.add('loaded');
            });
        });
    }
};

export default vimeoPlayer;